<template>
    <div
        v-if="modelValue"
        class="fixed top-0 w-full h-full bg-black/50 z-[80] flex justify-center items-center"
    >
        <div
            class="w-[55.375rem] max-h-screen bg-white flex flex-col overflow-hidden rounded shadow"
        >
            <!-- 헤더 -->
            <div class="px-9 pt-5.5 pb-3 flex justify-between items-center shrink-0">
                <p class="text-content-basic-1 font-inter-heading-14">View History</p>
                <button @click="hideThisModal">
                    <CloseIcon
                        :width="24"
                        :height="24"
                        color="text-content-basic-1"
                        weight="REGULAR"
                    />
                </button>
            </div>

            <!-- 테이블 -->
            <div class="px-9 pt-4">
                <div class="h-[37.5rem] max-h-[37.5rem] overflow-auto" style="max-height: calc(100vh - 12.5rem);">
                    <table class="w-full table-fixed">
                        <colgroup>
                            <col style="width: 7.5rem" />
                            <col style="width: 8.75rem" />
                            <col />
                        </colgroup>
                        <thead class="sticky top-0 bg-gray-100 z-10">
                            <tr class="font-inter-caption-2 text-content-basic-2 h-10">
                                <th class="text-left px-4 py-2">Timestamp</th>
                                <th class="text-left pr-4 py-2">Admin Name</th>
                                <th class="text-left pr-4 py-2">Action Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- prettier-ignore -->
                            <tr v-for="row in pagedTableData" :key="row.id" class="h-[3.75rem] font-inter-body-3 text-content-basic-1">
                            <td class="px-4 py-2"><div v-html="$dateFormatUtil.convertDateTimeToMMddyyyyHHmm(row.changedAt)" class="line-clamp-2 overflow-hidden text-ellipsis break-words"></div></td>
                            <td class="pr-4 py-2"><div class="line-clamp-2 overflow-hidden text-ellipsis break-words">{{ row.adminName }}</div></td>
                            <td class="pr-4 py-2">
                                <div v-html="row.actionDescription" class="overflow-hidden text-ellipsis break-words"></div>
                            </td>
                        </tr>
                            <template v-if="tableData.length === 0">
                                <tr class="h-14">
                                    <td rowspan="10" colspan="3">
                                        <div class="flex flex-col items-center gap-4">
                                            <ErrorIcon
                                                :width="60"
                                                :height="60"
                                                color="text-content-basic-4"
                                                weight="FILL"
                                            />
                                            <p>No results found.</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-for="i in 9" :key="i" class="h-14"></tr>
                            </template>
                        </tbody>
                    </table>
                </div>

                <!-- 페이지네이션 -->
                <DesignPagination
                    v-model="currentPage"
                    :totalContent="tableData.length"
                    :contentsPerPage="contentsPerPage"
                    :pageSize="pageSize"
                    class="py-3"
                />
            </div>

            <!-- 버튼 -->
            <div class="w-full h-20 px-6 py-5 flex justify-end shrink-0">
                <DesignButton
                    btnText="Close"
                    btnSize="MD"
                    btnType="QUATERNARY"
                    :btnDisabled="false"
                    @click-event="hideThisModal"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CloseIcon from '@/components/design-system/icon/close.vue';
import ErrorIcon from '@/components/design-system/icon/error.vue';
import DesignPagination from '@/components/design-system/design-pagination.vue';
import DesignButton from '@/components/design-system/design-button.vue';
import { DateFormatUtil } from '@/plugins/app-util.js';

export default {
    components: { CloseIcon, ErrorIcon, DesignPagination, DesignButton },
    emits: ['update:modelValue'],
    props: {
        modelValue: Boolean,
        featureName: {
            type: String,
            default: '',
            required: true,
        },
        contentsPerPage: {
            type: Number,
            default: 10,
        },
        pageSize: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            currentPage: 1,
            tableData: [],
        };
    },
    watch: {
        modelValue(newVal) {
            if (!newVal) {
                return;
            }

            this.getDataChangeLog();
        },
    },
    computed: {
        pagedTableData() {
            const start = (this.currentPage - 1) * this.contentsPerPage;
            const end = start + this.contentsPerPage;
            return this.tableData.slice(start, end);
        },
    },
    mounted() {},
    methods: {
        hideThisModal() {
            this.$emit('update:modelValue', false);
        },
        getDataChangeLog() {
            const json_query = JSON.stringify({
                featureName: this.featureName,
            });
            const url = this.$api('uri', 'get-data-change-log-list');
            this.$axios.get(url, { params: { json_query } }).then((res) => {
                this.tableData = res.data.data.list;
            });
        },
        convertDateTimeToMMddyyyyHHmm: DateFormatUtil.convertDateTimeToMMddyyyyHHmm,
    },
};
</script>
